import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/** Old address of the copy settings. */
export const Route = createFileRoute('/_app/strategy')({
  validateSearch: z.object({ s: z.string().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings/copy', search: search.s ? { s: search.s } : {}, replace: true });
  },
});
